import { useClient } from '../../../ClientProvider';
import useQuery from '../../../useQuery';
export const useHasNotConfiguredPlot = ({ plotId }) => {
    const client = useClient();
    const summaryRequest = useQuery(client.decitrait.summary({ plotId: plotId }));
    const hasNotConfiguredPlot = 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    summaryRequest.error?.fieldErrors?.error?.code?.message === 'PLOT_NOT_CONFIGURED';
    const { isLoading, refetch } = summaryRequest;
    return { hasNotConfiguredPlot, isLoading, refetch, summaryRequest };
};
